import { onMounted, onUnmounted, ref } from 'vue';
import { getHelsinkiDate } from '../utils/news';

// Refresh validity even when a player leaves the same page open overnight.
export function useNewsDate() {
  const today = ref(getHelsinkiDate());
  const refresh = () => { today.value = getHelsinkiDate(); };
  let timer;
  onMounted(() => {
    timer = setInterval(refresh, 60_000);
    document.addEventListener('visibilitychange', refresh);
  });
  onUnmounted(() => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', refresh);
  });
  return today;
}
